import './utils/polyfill'
import Vue from 'vue'
import clone from 'clone'
import './element-ui'
import './muse-ui'
import App from './App'
import router from './router'
import store from './store'
import './vuescroll'

// 全局组件
import './utils/components'
// 全局的过滤器
import './utils/filter'
// 全局变量
import GLOBAL_VAR from './utils/global'

import i18n from './i18n'

// deep clone
Vue.prototype.$clone = clone

Vue.prototype.$globalVar = GLOBAL_VAR

Vue.config.productionTip = false

// 存储初始状态的state，退出登录后用于重置state
sessionStorage.setItem('initState', JSON.stringify(store.state))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js